import { Fragment } from "react/jsx-runtime";
import { Href } from "../../../../../Constants/Constants";
import { ContactPollData } from "../../../../../Data/Messenger/Messenger";
import { useAppDispatch } from "../../../../../ReduxToolkit/Hooks";
import { toggleVisibility } from "../../../../../ReduxToolkit/Reducers/Messenger/Messenger";
import useOutside from "../../../../../Utils/useOutside";
import SvgIcon from "../../../../CommonComponents/SvgIcon";

const ContactPoll = ({ isEmojisVisible, setIsEmojisVisible }: any) => {
  const dispatch = useAppDispatch();
  const { ref, isComponentVisible, setIsComponentVisible } = useOutside(false);

  return (
    <Fragment>
      <div ref={ref} className={`contact-poll ${isComponentVisible && "active"}`}>
        <a className="icon-btn btn-outline-primary outside" href={Href} onClick={() => setIsComponentVisible(!isComponentVisible)}>
          <SvgIcon iconId="plus" />
        </a>
        <div className={`contact-poll-content ${isComponentVisible ? "d-block" : "d-none"}`}>
          {ContactPollData.map((item, index) => (
            <ul className={item.mainClass} key={index}>
              {item.contactPoll.map((item, index) => (
                <li key={index}>
                  <div className={item.class}>
                    <SvgIcon iconId={item.icon} />
                  </div>
                  <span>{item.title}</span>
                </li>
              ))}
            </ul>
          ))}
        </div>
      </div>
      <div>
        <a
          className="icon-btn btn-outline-primary button-effect toggle-sticker outside"
          href={Href}
          onClick={() => {
            dispatch(toggleVisibility("sticker"));
            setIsEmojisVisible(!isEmojisVisible);
          }}
        >
          <SvgIcon iconId="smile" />
        </a>
      </div>
      <div className="dot-btn dot-primary">
        <a
          className="icon-btn btn-outline-primary button-effect toggle-emoji"
          href={Href}
          onClick={() => {
            dispatch(toggleVisibility("emoji"));
            setIsEmojisVisible(!isEmojisVisible);
          }}
        >
          <SvgIcon iconId="smile-2" />
        </a>
      </div>
    </Fragment>
  );
};

export default ContactPoll;
